module.exports = __webpack_public_path__ + "img/delivery-otro.17ad65af.svg";